// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".e497b939f6f33e6f1ba9c0690de4d8835dbc5d84.chunk.bundle.js";
};